/**
 * Success Modal configuration
 */
export const modalConfig = {
  maxWidth: {
    mobile: 320,
    desktop: 400,
  },
  buttonHeight: {
    mobile: 34,
  },
};

/**
 * Warranty options
 */
export const warrantyOptions = [
  {
    id: "standard",
    label: "0 - 1 Year",
    value: false,
    description: "Standard warranty",
  },
  {
    id: "extended",
    label: "1 - 2 Yr (Ext)",
    value: true,
    description: "Extended warranty",
  },
];

/**
 * Modal content text
 */
export const modalContent = {
  title: "Congratulations",
  subtitle: "Your one-year Brand Warranty has been activated.",
  description:
    "Do you want to extend the product warranty to 2 years at nominal cost?",
  nextButton: "Next",
};
